<template>
  <aside class="menu app-sidebar-right animated">
      <article class="tile is-child box">
          <collapse>
            <collapse-item title="Components">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css
              #responsive
            </collapse-item>
            <collapse-item title="Elements">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css
              #responsive
            </collapse-item>
            <collapse-item title="Nests">
              <collapse>
                <collapse-item title="Nest Child">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css
                  #responsive
                </collapse-item>
              </collapse>
            </collapse-item>
          </collapse>
      </article>
  </aside>
</template>

<script>
  import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'

  export default {
    components: {
      Collapse,
      CollapseItem
    },
    props: {
      show: Boolean
    },

    data () {
      return {
        popularfiles: []
      }
    },
    created () {
      // fetch popular files
      this.$http({
        url: '/api/v1/search/popular',
        transformResponse: [(data) => {
          return JSON.parse(data.replace(/T00:00:00Z/g, ''))
        }]
      }).then((response) => {
        this.popularfiles.push(...response.data.files)
      }).catch((error) => {
        console.log(error)
      })
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  .app-sidebar-right {
    position: fixed;
    top: 50px;
    right: 0;
    bottom: 0;
    padding: 20px 0 50px;
    min-width: 45px;
    max-height: 100vh;
    width: 400px;
    height: calc(100% - 50px);
    z-index: 1024 -1;
    background: #FFF;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    overflow-y: auto;
    overflow-x: hidden;

  @include mobile() {
    transform: translate3d(-180px, 0, 0);
  }

  .icon {
    vertical-align: baseline;

  &
  .is-angle {
    position: absolute;
    right: 10px;
    transition: transform .377s ease;
  }

  }

  }
</style>



// WEBPACK FOOTER //
// RightSidebar.vue?042f7512